import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { AppRegistrationDTO, AppRegistrationWriteDTO } from '../interfaces/appRegistration';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppRegistrationService {

  constructor(private dataService: DataService) { }

  saveAppRegistration(appRegistrationId: number, appRegistration: AppRegistrationWriteDTO): Observable<AppRegistrationDTO> {
    if (appRegistrationId && appRegistrationId > 0) {
      return this.dataService.updateAppRegistration(appRegistrationId, appRegistration);
    } else {
      return this.dataService.createAppRegistration(appRegistration);
    }
  }

  deleteAppRegistration(appRegistration: AppRegistrationDTO) {
    if (!appRegistration || appRegistration.id == null || appRegistration.id == undefined || appRegistration.id < 1) {
      return this.dataService.deleteAppRegistration(appRegistration.id);
    } else return null;
  }

  getAppRegistrations(): Observable<any> {
    return this.dataService.getAppRegistrations();
  }

  getAppRegistration(appRegistrationId: number): Observable<any> {
    return this.dataService.getAppRegistration(appRegistrationId);
  }

  callBack(code: string, state: string) {
    return this.dataService.callBack(code, state);
  }

}
